import {
  type FrameEditableProps,
  type InstanceEditableProps,
} from '../../editor/commandBuilders.js';
import type { SceneNodeId } from '../../scene/sceneState.js';
import type { EditorCommands } from '../../editor/commands.js';

export interface SceneTreePropertyActionDeps {
  commands: Pick<EditorCommands, 'setFrameProperty' | 'setInstanceProperty'>;
  scheduleRender: () => void;
}

export function setFramePropertyAndRender<K extends keyof FrameEditableProps>(
  deps: SceneTreePropertyActionDeps,
  nodeId: SceneNodeId,
  prop: K,
  value: FrameEditableProps[K],
): void {
  deps.commands.setFrameProperty(nodeId, prop, value);
  deps.scheduleRender();
}

export function setInstancePropertyAndRender<K extends keyof InstanceEditableProps>(
  deps: SceneTreePropertyActionDeps,
  nodeId: SceneNodeId,
  prop: K,
  value: InstanceEditableProps[K],
): void {
  deps.commands.setInstanceProperty(nodeId, prop, value);
  deps.scheduleRender();
}
